
export default {
  // ui related
  searchKey: { value: '' }, // for some reason, binding wasn't working for a single value (searchKey), that's why I had to create an object (searchKey.value)
  activeTab: 'Location',
  tabs: ['Location', 'Biz Info', 'User List', 'Billing', /* 'Devices', */ 'Notes/Files'],
  activeMappingType: null,
  loading: {
    upsertBusiness: false,
    upsertBusinessUser: false,
    upsertBusinessBilling: false,
    upsertBusinessNote: false,
    upsertBusinessInfo: false
  },
  // database/api related
  business: {},
  businesses: [],

  products: []
}



// WEBPACK FOOTER //
// ./src/store/modules/business/state.js